class ReviewBarMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-review-bar-track]');
    this.group = this.querySelector('[data-review-bar-group]');
    if (!this.track || !this.group) return;

    this.clones = [];
    this.build = this.build.bind(this);

    requestAnimationFrame(this.build);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.build);
    }

    window.addEventListener('resize', this.build);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.build);
  }

  build() {
    const groupWidth = this.group.getBoundingClientRect().width;
    const viewport = this.getBoundingClientRect().width;
    if (groupWidth === 0 || viewport === 0) return;

    const needed = Math.max(2, Math.ceil(viewport / groupWidth) + 1);
    if (needed === this.clones.length + 1) return;

    this.clones.forEach((clone) => clone.remove());
    this.clones = [];

    for (let i = 1; i < needed; i++) {
      const clone = this.group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-review-bar-group');
      this.track.appendChild(clone);
      this.clones.push(clone);
    }

    this.track.style.setProperty('--review-bar-shift', `calc(-100% / ${needed})`);
  }
}

if (!customElements.get('review-bar-marquee')) {
  customElements.define('review-bar-marquee', ReviewBarMarquee);
}
